export const getTokenMapping = (state) => state.auth.tokenMapping;
export const getTokenMappingStatus = (state) => getTokenMapping(state).status;